// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Bolivia */
const BO = /^(?:(?:57|[67]\d)\d{6})$/;

export default BO;
